import React from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import axios from "axios";

const fetcher = (url) => axios.get(url, { withCredentials: false }).then((r) => r.data);

/**
 * PUBLIC verification page. By explicit security requirement:
 * does NOT show course, level, photo or enrolment status flags.
 * Only confirms this QR corresponds to an active member of the academy.
 */
export default function PublicCard() {
  const { token } = useParams();
  const url = `/api/eid/public/card/${token}`;
  const { data, error, isLoading } = useSWR(url, fetcher);

  return (
    <div className="min-h-screen bg-[#132C44] text-[#F6EFDF] flex items-center justify-center p-6">
      <div
        className="w-full max-w-md rounded-3xl bg-[#1E3A5F] p-8 shadow-2xl shadow-black/40 border border-[#F6EFDF]/10"
        data-testid="eid-public-card"
      >
        <div className="flex items-center justify-between">
          <span className="text-[10px] tracking-widest font-semibold opacity-80">
            VERIFICACIÓN · PINAR ENGLISH
          </span>
          <span className="h-8 w-8 rounded-md bg-[#8AA986] text-[#132C44] font-bold flex items-center justify-center text-[11px]">
            PE
          </span>
        </div>

        {isLoading && (
          <p className="mt-10 text-[13px] opacity-80">Verificando carnet…</p>
        )}

        {error && (
          <div className="mt-10" data-testid="eid-public-invalid">
            <h2 className="font-serif text-2xl">Carnet no válido</h2>
            <p className="mt-3 text-[13px] opacity-80">
              Este código QR no corresponde a un carnet vigente de Pinar
              English Academy.
            </p>
          </div>
        )}

        {data && (
          <>
            <h2 className="mt-10 font-serif text-3xl leading-tight" data-testid="eid-public-name">
              {data.firstName} {data.lastName}
            </h2>
            <p className="mt-2 text-[12px] uppercase tracking-widest opacity-70" data-testid="eid-public-code">
              {data.studentCode}
            </p>
            <div className="mt-8 border-t border-[#F6EFDF]/15 pt-5">
              <p className="text-[13px] opacity-85">
                Verificado como <strong>alumno/a de {data.issuer}</strong> ({data.verifiedAt}).
              </p>
            </div>
            <p className="mt-10 text-[11px] opacity-60">
              Esta vista pública no expone datos académicos. Para ver progreso y
              devoluciones, iniciá sesión en tu English ID.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
